
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
@media (min-width: 1024px) {.idb-graphs-projects {

    margin: auto;
  }.idb-graphs-projects {

    width: 75%;
  }
}.idb-graphs-projects--header {

  display: flex;
}.idb-graphs-projects--header {

  justify-content: center;
}.idb-graphs-projects--header {

  background-color: var(--gray-professional-lighten-5);
}.idb-graphs-projects--header {

  padding-left: 1rem;

  padding-right: 1rem;
}.idb-graphs-projects--header idb-heading {

  color: var(--gray-professional-darken-1);
}.idb-graphs-projects--action-wrapper {

  background-color: var(--gray-professional-lighten-5);
}.idb-graphs-projects--bars {

  display: flex;
}.idb-graphs-projects--bars {

  flex-direction: column;
}@media (min-width: 1024px) {.idb-graphs-projects--bars {

    flex-direction: row;
  }
}.idb-graphs-projects--bars-wrapper {

  width: 100%;
}@media (min-width: 1024px) {.idb-graphs-projects--bars-wrapper {

    width: 50%;
  }
}@media (min-width: 1024px) {.idb-graphs-projects--bars-wrapper {

    padding-left: 0.5rem;

    padding-right: 0.5rem;
  }
}.idb-graphs-projects idb-stat-bar {

  margin-bottom: 0.5rem;
}

idb-card-grid {

  margin: 0px;

  padding-top: 0px;

  padding-bottom: 1rem;
}

.fieldset-wrapper {

  display: flex;

  flex-direction: column;

  justify-content: center;

  padding-left: 1rem;

  padding-right: 1rem;

  padding-bottom: 1rem;
}

@media (min-width: 1280px) {.fieldset-wrapper {

    flex-direction: row;
  }.fieldset-wrapper {

    padding-left: 0px;

    padding-right: 0px;
  }
}

.fieldset-wrapper .form-item {

  margin: 0.5rem;
}

@media (min-width: 1024px) {.fieldset-wrapper .form-item {

    margin-left: 1rem;

    margin-right: 1rem;
  }
}

input[type='radio'] {

  float: left;

  margin: 0px;

  box-sizing: border-box;

  display: inline-flex;

  cursor: pointer;

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;

  align-items: center;

  justify-content: center;

  border-radius: 9999px;

  border-width: 2px;

  border-style: solid;

  border-color: var(--gray-professional-lighten-1);

  color: var(--neutral-white);

  outline: 2px solid transparent;

  outline-offset: 2px;

  transition-property: all;

  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  transition-duration: 150ms;

  min-width:1.25rem;
  width:25px;
  height:25px;
  margin-top:-2px;
}

input[type='radio'] + label {

  margin-bottom: 0px;
}

input[type='radio'] + label {

  margin-top: 0px;
}

input[type='radio'] + label {

  display: inline-block;
}

input[type='radio'] + label {

  cursor: pointer;
}

input[type='radio'] + label {

  padding-left: 0.75rem;
}

input[type='radio'] + label {

  font-weight: var(--fw-semibold);
}

input[type='radio'] + label {

  color: var(--gray-professional-lighten-1);
}

input[type='radio'] + label {

  transition-property: all;

  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  transition-duration: 150ms;
}

input[type='radio'].error {

  border-color: var(--ui-errorText);
}

input[type='radio']::before {

  display: block;
}

input[type='radio']::before {

  border-radius: 9999px;
}

input[type='radio']::before{

    content:'';
    width:15px;
    height:15px;
  }

input[type='radio']:hover, input[type='radio']:focus {

  border-width: 3px;
}

input[type='radio']:hover, input[type='radio']:focus {

  border-color: var(--blue-responsible-main);
}

input[type='radio']:hover, input[type='radio']:focus {

  background-color: var(--outline-white);
}

input[type='radio']:hover + label, input[type='radio']:focus + label {

  color: var(--blue-responsible-main);
}

input[type='radio']:checked {

  border-color: var(--blue-responsible-main);
}

input[type='radio']:checked::before {

  background-color: var(--blue-responsible-main);
}

input[type='radio'].error:checked {

  border-color: var(--ui-errorText);
}

input[type='radio'].error:checked::before {

  background-color: var(--ui-errorText);
}

input[type='radio'][disabled] + label {

  color: var(--gray-professional-main);
}

input[type='radio'][disabled]:checked {

  border-color: var(--gray-cosmopolitan-main);
}

input[type='radio'][disabled]:checked::before {

  background-color: var(--gray-cosmopolitan-main);
}

idb-button {

  background-color: var(--gray-professional-main);
}

idb-button.active {

  background-color: var(--cyan-near-main);
}
`;